import { ApiLink } from "api/shared";
import cookies from "js-cookie";

import config from "config";

import TextLink from "../TextLink";
import styles from "./ContactSupport.module.css";

export const ContactSupport: React.FC<{
  clientName: string;
  link?: ApiLink["link"];
  onFocus?: () => void;
  onBlur?: () => void;
}> = ({ clientName, link, onFocus, onBlur }) => {
  const portalAuthCookie = cookies.get(
    `app-${config.ENVIRONMENT.toLowerCase()}-clientid`
  );

  const getContactSupportText = () => {
    if (!link?.href) {
      return `Please contact ${clientName}`;
    }
    if (link.href.startsWith("tel:")) {
      return `Contact support at ${link.href.replace(
        /mailto:|tel:|https?:\/\//g,
        ""
      )}`;
    }
    return "Contact support";
  };

  return (
    <>
      {!link?.href && (
        <div data-testid="support-text" className={styles.contactSupportText}>
          {getContactSupportText()}
        </div>
      )}
      {link?.href && (
        <TextLink
          href={link.href}
          data-testid="support-link"
          analyticsName="Support"
          eventProperties={{
            isLoggedIntoPortal: !!portalAuthCookie,
          }}
          onFocus={onFocus}
          onBlur={onBlur}
          className={styles.contactSupportLink}
          target={link.href.startsWith("tel") ? "" : "_blank"}
        >
          {getContactSupportText()}
        </TextLink>
      )}
    </>
  );
};
